import { Router } from '@angular/router';
import { UserService } from '../services';
import { AuthService } from '@ml/auth/services';
import { catchError, first, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../services/user.service";
import * as i3 from "../../auth/services/auth.service";
var AuthGuard = /** @class */ (function () {
    function AuthGuard(router, userService, authService) {
        this.router = router;
        this.userService = userService;
        this.authService = authService;
    }
    AuthGuard.prototype.canActivate = function (next, state) {
        var _this = this;
        if (!this.authService.hasTokens) {
            var url = state.url.split('?')[0];
            this.router.navigate(['/auth'], {
                queryParams: {
                    url: url,
                    queryParams: JSON.stringify(next.queryParams)
                }
            });
            return false;
        }
        return this.userService.get().pipe(first(), map(function (user) {
            if (user && !user.passwordChanged) {
                /*
                this.router.navigate(['change-password']);
                */
            }
            return true;
        }), catchError(function (err) {
            _this.authService.logout();
            return _this.router.navigate(['auth']);
        }));
    };
    AuthGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.UserService), i0.ɵɵinject(i3.AuthService)); }, token: AuthGuard, providedIn: "root" });
    return AuthGuard;
}());
export { AuthGuard };
